import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { AppArea } from '../../config/areas';
import { areaHref } from '../../config/areas';

interface ManagementLinkProps {
  /** Studio/Settings areas the user can reach, already filtered by role. */
  areas: readonly AppArea[];
  current: AppArea | undefined;
  roles: readonly string[];
}

/** The one door from the end-user experience into template/system management (author, admin). */
export function ManagementLink({ areas, current, roles }: ManagementLinkProps) {
  const { t } = useTranslation();

  if (areas.length === 0) return null;

  const active = areas.some((area) => area.key === current?.key);

  return (
    <Link
      to={areaHref(areas[0], roles)}
      aria-label={t('nav.management')}
      title={t('nav.management')}
      aria-current={active ? 'page' : undefined}
      className={`inline-flex shrink-0 items-center justify-center rounded border border-input p-1.5 transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring ${
        active ? 'bg-muted text-foreground' : 'bg-surface text-muted-foreground hover:bg-muted hover:text-foreground'
      }`}
    >
      <Cog6ToothIcon className="size-5" aria-hidden="true" />
    </Link>
  );
}
